import React from 'react';
import { Frown, DollarSign, Zap, HelpCircle } from 'lucide-react';
export function PainSection() {
  const pains = [{
    icon: <Frown className="w-8 h-8 text-alphaGold" data-id="element-329" />,
    title: 'Entrenas duro y no ves resultados',
    desc: 'Horas en el gym, sudor, esfuerzo… y el espejo no muestra nada diferente. Sin la nutrición correcta, tu cuerpo no puede crecer sin importar cuánto entrenes.'
  }, {
    icon: <DollarSign className="w-8 h-8 text-alphaGold" data-id="element-330" />,
    title: 'Los suplementos importados cuestan una fortuna',
    desc: 'Pagas precios exorbitantes por marcas extranjeras con flete, impuestos y demoras. Mientras tanto, tu progreso espera. Ya no tiene por qué ser así.'
  }, {
    icon: <Zap className="w-8 h-8 text-alphaGold" data-id="element-331" />,
    title: 'Te falta energía y recuperación',
    desc: 'Terminas el entrenamiento destruido, tardas días en recuperarte y perdés sesiones por cansancio. Tu cuerpo está pidiendo combustible de calidad, no aguante de voluntad.'
  }, {
    icon: <HelpCircle className="w-8 h-8 text-alphaGold" data-id="element-332" />,
    title: 'No sabés qué suplemento elegir',
    desc: 'El mercado está lleno de opciones y promesas vacías. El miedo a gastar mal el dinero te paraliza. Nosotros te guiamos al suplemento exacto para tu objetivo.'
  }];
  return <section className="bg-gradient-to-b from-dark-900 via-dark-700 to-dark-900 py-[80px] px-5" data-id="element-333">
      <div className="max-w-[1100px] mx-auto" data-id="element-334">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-335">
          ¿Te Sentís Identificado?
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-336">
          Si alguna de estas situaciones te pasa, tenemos la solución exacta que
          necesitás.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10" data-id="element-337">
          {pains.map((pain, idx) => <div key={idx} className="bg-dark-600 border border-dark-300 border-l-4 border-l-alphaGold p-[30px_25px] rounded" data-id="element-338">
              <div className="mb-4" data-id="element-339">{pain.icon}</div>
              <h3 className="text-[1.1rem] font-bold mb-2.5 text-white" data-id="element-340">
                {pain.title}
              </h3>
              <p className="text-[#999] leading-[1.7] text-[0.95rem]" data-id="element-341">
                {pain.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}